module.exports = __webpack_public_path__ + "28a523cbd33ab03e8edf4ab3d1fb9920.svg";